import { render, staticRenderFns } from "./verCobro.vue?vue&type=template&id=326f3fc4&scoped=true&"
import script from "./verCobro.vue?vue&type=script&lang=js&"
export * from "./verCobro.vue?vue&type=script&lang=js&"
import style0 from "./verCobro.vue?vue&type=style&index=0&id=326f3fc4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f3fc4",
  null
  
)

export default component.exports